// Import Packages
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import * as Base64Binary from "base64-arraybuffer";

// Import Pages
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { Checkboxes, FileInputMateDrive } from "../../../FlowConfigurationInputs";
import { CredentialPicker } from "../../../FlowConfigurationInputs/CredentialPicker/CredentialPicker";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import AutomService from "../../../../services/AutomService/AutomService";

// Import Material UI
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { Box, MenuItem, Select } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import InputBase from '@material-ui/core/InputBase';

// Import Recoil
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated, isActionValueController } from '../../../../helpers/helper';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 2,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '0.5px solid #D5D5D5',
    paddingLeft: 5,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.

  },
}))(InputBase);

// style tabpanel
function TabPanel({ children, value, index }) {
  return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

//PDF EXTRACT IMAGE
export default function ExtractImage({
  action,
  variables,
  showAlert,
  setOpenVariable,
  automId,
  variableRender,
  automVersionId
}) {
  const [pageValue, setPageValue] = useState("allpages");
  const [imageType, setImageType] = useState("jpeg");
  const [compressionType, setCompressionType] = useState("none");
  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);

  const [value, setValue] = useState(0);
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.PDF.";
  const options = {
    fileInput: {
      checkExtension: (ext) => {
        if (ext.toLocaleLowerCase() !== 'pdf') {
          showAlert(t(label + 'UPLOAD-PDF-ONLY'));
          return false;
        }
        return true;
      },
      fileType: ".pdf",
    },
    checkboxes: { label: label + "OVERWRITE" },
  };
  //SET default value in Extract Image
  useEffect(() => {
    if (!action.fields.allPages) {
      action.fields.allPages = { value: true };
      setPageValue("allpages");
    } else {
      if (action.fields.allPages.value) {
        setPageValue("allpages");
      } else {
        setPageValue("pages");
      }
    }
    if (!action.fields.imageType) {
      action.fields.imageType = { value: imageType, isRequired: true };
    } else {
      setImageType(action.fields.imageType.value);
      // if (action.fields.imageType.value === "tiff") {
      //   if (!action.fields.compressionType) {
      //     action.fields.compressionType = { value: "none" };
      //   }
      //   setCompressionType(action.fields.compressionType.value);
      //   delete action.fields.jpegQuality;
      // } else if (action.fields.imageType.value === "jpeg") {
      //   delete action.fields.compressionType;
      // } else {
      //   delete action.fields.jpegQuality;
      //   delete action.fields.compressionType;
      // }
    }
    if (!action.fields.fileType) {
      action.fields.fileType = { value: "FILE" };
    } else {
      if (action.fields.fileType.value === "TEXT") setValue(1);
      else setValue(0);
    }
  }, [action, variables]);

  // select radio button action fields edit
  function handleChange(event) {
    setPageValue(event.target.value);


    if (event.target.value === "allpages") {
      action.fields.allPages.value = true;
      // action.fields.pages = { value: `` };
    } else if (event.target.value === "pages") {
      action.fields.allPages.value = false;
      //action.fields.pages = { value: action.fields.pages.htmlValue };
    }

    const field = initialActionsData[action.id]?.fields.allPages;
    const oldValue = !field ? undefined : field.value;
    CheckIfFlowUpdated('allPages', action, oldValue, event.target.value === "allpages", setSaveAvailable, setChangeFields, changedFieldsState);
  }

  // selected set image type value
  function handleImageType(event) {
    setImageType(event.target.value);
    action.fields.imageType.value = event.target.value;
    if (event.target.value === "jpeg") {
      delete action.fields.compressionType;
    } else if (event.target.value === "tiff") {
      delete action.fields.jpegQuality;
    } else {
      delete action.fields.jpegQuality;
      delete action.fields.compressionType;
    }

    const field = initialActionsData[action.id]?.fields.imageType;
    const oldValue = !field ? undefined : field.value;
    CheckIfFlowUpdated('imageType', action, oldValue, event.target.value, setSaveAvailable, setChangeFields, changedFieldsState);
  }

  // IF selected image type is TIFF then COMPRESSION TYPE
  // function handleCompressionType(event) {
  //   setCompressionType(event.target.value);
  //   if (!action.fields.compressionType) {
  //     action.fields.compressionType = { value: event.target.value };
  //   } else {
  //     action.fields.compressionType.value = event.target.value;
  //   }

  //   const field = initialActionsData[action.id]?.fields.compressionType;
  //   const oldValue = !field ? undefined : field.value;
  //   CheckIfFlowUpdated('compressionType', action, oldValue, event.target.value, setSaveAvailable, setChangeFields, changedFieldsState);
  // }

  //selected change tabs and set value
  function handleChangeTabs(newValue) {
    setValue(newValue);
    if (newValue === 1) {
      action.fields.path.type = "TEXT";
      action.fields.fileType.value = 'TEXT';
      delete action.fields.path.fileName;
      delete action.fields.path.byteValue;
      delete action.fields.path.extension;
      delete action.fields.path.fileSize;
      delete action.fields.path.value;
    } else {
      //action.fields.path.type = "FILE";
      action.fields.fileType.value = 'FILE';
      delete action.fields.path.value;
      delete action.fields.path.htmlValue;
    }
  }

  async function handleGetImage() {
    let res = isActionValueController(action.fields);
    if (res.indexOf(false) === -1) {
      action.automId = automId;
      action.automVersionId = automVersionId;
      let response = await AutomService.runAction(action);
      if (response) {
        if (response.files?.length > 0) {
          response.files.map(
            (item) => {
              let a = document.createElement("a"); //Create <a>
              a.href = `data:image/${imageType};base64,` + Base64Binary.encode(item.data); //Image Base64 Goes here
              a.download = `Image.${imageType}`; //File name Here
              a.click(); //Downloaded file
            }

          );
        }

        if (response.message.includes("System Error:")) {
          showAlert(response.message.replace("System Error:", ""), response.status);
        } else {
          showAlert(t("FLOW-MESSAGES.LIBRARY." + response?.message), response.status);
        }
      }
    } else {
      showAlert(t("ACTIVE-DIRECTORY.NOT-NULL"), false);
    }
  }

  return (
    <div>
      <div className="conf-field-container">

        <FieldLabel name={t(label + "PATH")} is_required />
        <div className="condition-tabs">
          <button
            className={`f-s-11 ${value === 0 ? 'condition-active' : ''}`}
            onClick={() => handleChangeTabs(0)}>
            Select File
          </button>
          <button
            className={`f-s-11 ${value === 1 ? 'condition-active' : ''}`}
            onClick={() => handleChangeTabs(1)}>
            Custom String
          </button>
        </div>
        <TabPanel value={value} index={0}>
          <FileInputMateDrive
            action={action}
            inputName="path"
            options={options.fileInput}
            isRequired={true}
            isSize={true}
            hideRequired
            autom_id={automId}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TextInput
            action={action}
            inputName="path"
            isRequired={false}
            setOpenVariable={setOpenVariable}
            variables={variables}
            autom_id={automId}
            mateDrivePath="filePath"
          />
        </TabPanel>
      </div>
      <div className="conf-field-container">

        <FieldLabel name={t(label + "USERPASSWORD")} />
        <CredentialPicker
          action={action}
          inputName="userPassword"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          isPassword={true}
        />
      </div>
      <div className="conf-field-container">

        <FieldLabel name={t(label + "OWNERPASSWORD")} />
        <CredentialPicker
          action={action}
          inputName="ownerPassword"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          isPassword={true}
        />
      </div>
      <div className="conf-field-container">
        <FormControl component="fieldset">

          <FieldLabel name={t(label + "PAGERANGE")} />
          <RadioGroup
            aaria-label="gender"
            name="gender1"
            value={pageValue}
            onChange={handleChange}
          >
            <FormControlLabel
              value="allpages"
              control={<Radio color="#C4C4C4" size="small" />}
              label={t(label + "ALLPAGES")}
            />
            <FormControlLabel
              value="pages"
              control={<Radio color="#C4C4C4" size="small" />}
              label={t(label + "PAGES")}
            />
          </RadioGroup>
        </FormControl>
        <div
          className="conf-field-container"
          style={{ pointerEvents: pageValue !== "pages" && "none" }}
        >
          <TextInput
            action={action}
            inputName="pages"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired={false}
          />
          <small className="conf-field-desc">{"{e.g. 1,3 5-10}"}</small>
        </div>
      </div>
      <div className="conf-field-container">

        <FieldLabel name={t(label + "CONVERT-IMAGE")} is_required />
        <FormControl variant="outlined" fullWidth style={{ width: "90%" }}>
          <Select value={imageType} onChange={handleImageType} input={(imageType) ? null : <BootstrapInput />}>
            {/* <MenuItem value="tiff">TIFF</MenuItem> */}
            <MenuItem value="jpeg">JPEG</MenuItem>
            <MenuItem value="jpg">JPG</MenuItem>
            {/* <MenuItem value="bmp">BMP</MenuItem>
            <MenuItem value="gif">GIF</MenuItem> */}
            <MenuItem value="png">PNG</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className="conf-field-container">
        {/* {imageType === "tiff" && (
          <>
            <FieldLabel name={t(label + "COMPRESSION-TYPE")} />
            <FormControl variant="outlined" fullWidth>
              <Select
                value={compressionType}
                onChange={handleCompressionType}
              >
                <MenuItem value="none">NONE</MenuItem>
                <MenuItem value="lzw">LZW</MenuItem>
                <MenuItem value="ccttgroup3">CCTT Group 3</MenuItem>
                <MenuItem value="ccttgroup4">CCTT Group 4</MenuItem>
              </Select>
            </FormControl>
          </>
        )} */}
        {/* {imageType === "jpeg" && (
          <>
            <FieldLabel name={t(label + "QUALITY")} />
            <TextInput
              action={action}
              inputName="jpegQuality"
              variables={variables}
              setOpenVariable={setOpenVariable}
              isRequired={false}
              defaultValue="100"
            />
          </>
        )} */}
      </div>

      <div className="conf-field-container">
        <Checkboxes
          action={action}
          inputName="overwriteFile"
          options={options.checkboxes}
          isRequired={false}
        />
      </div>
      {/* <div className="conf-field-container-horizontal">
        <div className="conf-field-container" style={{ marginRight: 10 }}>
          <FieldLabel name={`X ${t(label + "RESOLUTION")}(dpi)`} />
          <TextInput
            action={action}
            inputName="xResolution"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired={false}
            defaultValue="200"
          />
        </div>
        <div className="conf-field-container">
          <FieldLabel name={`Y ${t(label + "RESOLUTION")}(dpi)`} />
          <TextInput
            action={action}
            inputName="yResolution"
            variables={variables}
            setOpenVariable={setOpenVariable}
            isRequired={false}
            defaultValue="200"
          />
        </div>
      </div> */}
      <div className="conf-field-container">
        <FieldLabel name={t(label + "FOLDER-PATH")} is_required />
        <TextInput
          action={action}
          inputName="folderPath"
          variables={variables}
          setOpenVariable={setOpenVariable}
          fieldType="string"
          displayName={t(label + 'FOLDER-PATH')}
          hideRequired
          isRequired
          autom_id={automId}
        />
      </div>
      <div className="conf-field-container">
        <FieldLabel name={t("CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE")} />
        <VariablePicker
          action={action}
          inputName="set"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          isRequired={false}
          filter="array"
        />
        <small className="conf-field-desc"><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
      </div>
      <Button
        onClick={handleGetImage}
        variant="outlined"
        style={{ backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "100%", border: "none", marginTop: 20, marginBottom: 20 }}>
        {t(label + "GET-IMAGE")}
      </Button>
    </div>
  );
}
